// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/event_type/v1/event_type.proto (package fingertip.creator.event_type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { CreateEventTypeRequest, CreateEventTypeResponse, DeleteEventTypeRequest, DeleteEventTypeResponse, GetEventTypePublicRequest, GetEventTypePublicResponse, GetEventTypeRequest, GetEventTypeResponse, GetEventTypeScheduleRequest, GetEventTypeScheduleResponse, GetEventTypesPublicRequest, GetEventTypesPublicResponse, GetEventTypesRequest, GetEventTypesResponse, UpdateEventTypeRequest, UpdateEventTypeResponse, UpdateEventTypesOrderRequest, UpdateEventTypesOrderResponse } from "./event_type_pb.js";

/**
 * @generated from rpc fingertip.creator.event_type.v1.EventTypeService.GetEventTypes
 */
export const getEventTypes = {
  localName: "getEventTypes",
  name: "GetEventTypes",
  kind: MethodKind.Unary,
  I: GetEventTypesRequest,
  O: GetEventTypesResponse,
  service: {
    typeName: "fingertip.creator.event_type.v1.EventTypeService"
  }
};

/**
 * @generated from rpc fingertip.creator.event_type.v1.EventTypeService.GetEventTypePublic
 */
export const getEventTypePublic = {
  localName: "getEventTypePublic",
  name: "GetEventTypePublic",
  kind: MethodKind.Unary,
  I: GetEventTypePublicRequest,
  O: GetEventTypePublicResponse,
  service: {
    typeName: "fingertip.creator.event_type.v1.EventTypeService"
  }
};

/**
 * @generated from rpc fingertip.creator.event_type.v1.EventTypeService.GetEventTypesPublic
 */
export const getEventTypesPublic = {
  localName: "getEventTypesPublic",
  name: "GetEventTypesPublic",
  kind: MethodKind.Unary,
  I: GetEventTypesPublicRequest,
  O: GetEventTypesPublicResponse,
  service: {
    typeName: "fingertip.creator.event_type.v1.EventTypeService"
  }
};

/**
 * @generated from rpc fingertip.creator.event_type.v1.EventTypeService.GetEventType
 */
export const getEventType = {
  localName: "getEventType",
  name: "GetEventType",
  kind: MethodKind.Unary,
  I: GetEventTypeRequest,
  O: GetEventTypeResponse,
  service: {
    typeName: "fingertip.creator.event_type.v1.EventTypeService"
  }
};

/**
 * @generated from rpc fingertip.creator.event_type.v1.EventTypeService.CreateEventType
 */
export const createEventType = {
  localName: "createEventType",
  name: "CreateEventType",
  kind: MethodKind.Unary,
  I: CreateEventTypeRequest,
  O: CreateEventTypeResponse,
  service: {
    typeName: "fingertip.creator.event_type.v1.EventTypeService"
  }
};

/**
 * @generated from rpc fingertip.creator.event_type.v1.EventTypeService.UpdateEventType
 */
export const updateEventType = {
  localName: "updateEventType",
  name: "UpdateEventType",
  kind: MethodKind.Unary,
  I: UpdateEventTypeRequest,
  O: UpdateEventTypeResponse,
  service: {
    typeName: "fingertip.creator.event_type.v1.EventTypeService"
  }
};

/**
 * @generated from rpc fingertip.creator.event_type.v1.EventTypeService.UpdateEventTypesOrder
 */
export const updateEventTypesOrder = {
  localName: "updateEventTypesOrder",
  name: "UpdateEventTypesOrder",
  kind: MethodKind.Unary,
  I: UpdateEventTypesOrderRequest,
  O: UpdateEventTypesOrderResponse,
  service: {
    typeName: "fingertip.creator.event_type.v1.EventTypeService"
  }
};

/**
 * @generated from rpc fingertip.creator.event_type.v1.EventTypeService.DeleteEventType
 */
export const deleteEventType = {
  localName: "deleteEventType",
  name: "DeleteEventType",
  kind: MethodKind.Unary,
  I: DeleteEventTypeRequest,
  O: DeleteEventTypeResponse,
  service: {
    typeName: "fingertip.creator.event_type.v1.EventTypeService"
  }
};

/**
 * @generated from rpc fingertip.creator.event_type.v1.EventTypeService.GetEventTypeSchedule
 */
export const getEventTypeSchedule = {
  localName: "getEventTypeSchedule",
  name: "GetEventTypeSchedule",
  kind: MethodKind.Unary,
  I: GetEventTypeScheduleRequest,
  O: GetEventTypeScheduleResponse,
  service: {
    typeName: "fingertip.creator.event_type.v1.EventTypeService"
  }
};
